import { useTranslation } from 'react-i18next';
import * as S from "./styled";
import ButtonDefault from "../../components/ButtonDefault";
import logo from "../../assets/Svg/icon.svg";
import visa from "../../assets/Img/visa.png";
import right from "../../assets/Img/right.png";
import mastercar from "../../assets/Img/mastercar.png";
import ssl from "../../assets/Img/ssl.png";
import PlanCard from "../../components/CardPlan";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Loading } from "../../components/Loading";
import loafing from '../../assets/Lottie/loading.json';
import success from '../../assets/Lottie/success.json';
import failed from '../../assets/Lottie/failed.json';
import processing from '../../assets/Lottie/loading_payment.json';
import theme from "../../theme";
import { usePromotionController } from "../../controller/promotionController";
import CardsAssessments from "../../components/CardsAssessments";
import { Carousel } from 'primereact/carousel';
import * as Icon from "@phosphor-icons/react";
import CardList from '../../components/CardLists';
import apphomeEN from "../../assets/Img/apphomeEN.png";
import apphomePT from "../../assets/Img/apphomePT.png";
import Footer from '../../components/Footer';

export default function Promotion() {
    const { t } = useTranslation();
    const languageTag = navigator.language.split('-')[0];

    const {
        reviews,
        benefits,
        testimonials,
        data,
        imagesAppPT,
        imagesAppEN,
        responsive,
        loadingCheckout,
        planing,
        handleCardClick,
        handlePurchase,
        loading,
        selectedPlan,
        showFailure,
        showProcessing,
        showSuccess
    } = usePromotionController();

    let loopAnimation = (!showSuccess && !showFailure);

    let onAnimationFinishLogic = () => {
        if (!showProcessing) {
            window.location.href = '/promotion'
        }
    };

    if (loading) {
        return (
            <Loading
                animationData={loafing}
                height={100}
                width={100}
                bg={theme.COLORS.BACKGROUND}
                title={t('loading_title')}
            />
        );
    }

    if (showSuccess || showFailure || showProcessing) {
        return (
            <Loading
                width={200}
                height={200}
                animationData={
                    showSuccess
                        ? success
                        : showFailure
                            ? failed
                            : processing
                }
                bg={theme.COLORS.BACKGROUND}
                onAnimationFinish={onAnimationFinishLogic}
                loop={loopAnimation}
            />
        );
    }

    const responsiveOptions = [
        {
            breakpoint: '1400px',
            numVisible: 3,
            numScroll: 1
        },
        {
            breakpoint: '1199px',
            numVisible: 3,
            numScroll: 1
        },
        {
            breakpoint: '768px',
            numVisible: 1,
            numScroll: 1
        },
        {
            breakpoint: '575px',
            numVisible: 1,
            numScroll: 1
        }
    ];

    const productTemplate = (item: any) => {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <S.SliderImage src={item} alt="Product" />
            </div>
        );
    };

    const productTemplateAssessments = (item: any, index: any) => {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CardsAssessments
                    key={index}
                    data={item}
                />
            </div>
        );
    };

    return (
        <S.Container>
            <S.SubContainer>
                <S.Title>
                    {t('promotion_title')}
                </S.Title>
                <S.Description>
                    {t('promotion_description')}
                </S.Description>

                <S.Content>
                    <Carousel
                        value={languageTag === 'pt' ? imagesAppPT : imagesAppEN}
                        numVisible={3}
                        numScroll={3}
                        responsiveOptions={responsiveOptions}
                        itemTemplate={productTemplate}
                        prevIcon={<Icon.CaretLeft size={30} color={theme.COLORS.PRIMARY} />}
                        nextIcon={<Icon.CaretRight size={30} color={theme.COLORS.PRIMARY} />}
                        orientation="horizontal"
                        autoplayInterval={2000}
                    />
                </S.Content>

                <S.SubContent>
                    <S.Title>
                        {t('what_you_get_title')}
                    </S.Title>
                    <S.Description>
                        {t('what_you_get_description')}
                    </S.Description>
                </S.SubContent>

                <S.ContentPremium>
                    {data.map(item => (
                        <S.ContainerCard
                            key={item.id}>
                            <S.Image src={item.image} alt={item.title} />
                            <S.TitlePremium>{item.title}</S.TitlePremium>
                            <S.DescriptionPremium>{item.description}</S.DescriptionPremium>
                        </S.ContainerCard>
                    ))}
                </S.ContentPremium>
                <S.SubContent>
                    <S.Title>
                        {t('users_love_title')}
                    </S.Title>
                    <S.Description>
                        {t('users_love_description')}
                    </S.Description>
                </S.SubContent>
                <S.Content>
                    <Carousel
                        value={reviews}
                        numVisible={3}
                        numScroll={3}
                        responsiveOptions={responsiveOptions}
                        itemTemplate={productTemplateAssessments as any}
                        prevIcon={<Icon.CaretLeft size={30} color={theme.COLORS.PRIMARY} />}
                        nextIcon={<Icon.CaretRight size={30} color={theme.COLORS.PRIMARY} />}
                        orientation="horizontal"
                        autoplayInterval={2000}
                    />
                </S.Content>

                <S.SubContent>
                    <S.Title>
                        {t('visible_results_title')}
                    </S.Title>
                    <S.Description>
                        {t('visible_results_description')}
                    </S.Description>
                </S.SubContent>

                {planing.map((item) => (
                    <PlanCard
                        key={item.flat}
                        bestOffer={item.bestOffer}
                        flat={item.flat}
                        price={item.price}
                        value={item.value}
                        isSelected={selectedPlan?.flat === item.flat}
                        onClick={item.link}
                    />
                ))}

                {/* <S.SubContent>
                    <ButtonDefault
                        title={loading ? <Loading
                            animationData={loafing}
                            height={50}
                            width={50}
                        /> : t('button_text')}
                        onClick={handlePurchase}
                    />
                </S.SubContent> */}

                <S.SubContent>
                    <S.Title>
                        {t('results_title')}
                    </S.Title>
                    <S.Description>
                        {t('results_description')}
                    </S.Description>
                </S.SubContent>

                <S.SubContentTestimonial>
                    {testimonials.map((item) => (
                        <S.SubContent key={item.name}>
                            <S.TestimonialImage src={item.image} />
                            <S.ContentTestimonial>
                                <S.Description>
                                    {item.name} <span style={{ color: theme.COLORS.ERROR, fontWeight: '700' }} >{item.weightLoss}</span>
                                </S.Description>
                            </S.ContentTestimonial>
                            <S.ContentTestimonial>
                                <S.DescriptionPremium>
                                    {item.testimonial}
                                </S.DescriptionPremium>
                            </S.ContentTestimonial>
                        </S.SubContent>
                    ))}
                </S.SubContentTestimonial>

                <S.SubContent>
                    <S.Title>
                        {t('usePromotionController_economy_title')}
                    </S.Title>
                </S.SubContent>

                <S.ContainerSave>
                    <S.ContainerSaveRight>
                        {benefits.map(item => (
                            <CardList
                                title={item.title}
                                img={item.image}
                                price={item.price}
                            />
                        ))}
                    </S.ContainerSaveRight>
                    <S.ContainerSaveLeft>
                        <S.ImageApp src={languageTag ? apphomePT : apphomeEN} alt="" />
                    </S.ContainerSaveLeft>
                </S.ContainerSave>

                <S.SubContent>
                    <S.Title>
                        {t('visible_results_title')}
                    </S.Title>
                    <S.Description>
                        {t('visible_results_description')}
                    </S.Description>
                </S.SubContent>

                <S.SubContent>
                    {planing.map((item) => (
                        <PlanCard
                            key={item.flat}
                            bestOffer={item.bestOffer}
                            flat={item.flat}
                            price={item.price}
                            value={item.value}
                            isSelected={selectedPlan?.flat === item.flat}
                            onClick={item.link}
                        />
                    ))}
                    {/* <ButtonDefault
                        title={loading ? <Loading
                            animationData={loafing}
                            height={50}
                            width={50}
                        /> : t('button_text')}
                        onClick={handlePurchase}
                    /> */}
                </S.SubContent>
                <S.SubContent>
                    <S.Image style={{ width: 60, height: 60 }} src={logo} alt='logo' />
                    <S.SubContent>
                        <S.TitlePremium>{t('payment_secure_title')}</S.TitlePremium>
                        <div style={{ padding: 10, display: 'flex', justifyContent: 'center', width: '30%' }} >
                            <S.Image style={{ width: 60 }} src={visa} alt='visa' />
                            <S.Image style={{ width: 80 }} src={ssl} alt='ssl' />
                            <S.Image style={{ width: 60 }} src={mastercar} alt='mastercar' />
                        </div>
                    </S.SubContent>
                </S.SubContent>
                <ToastContainer />
            </S.SubContainer>
            <Footer />
        </S.Container>
    );
}
